/**
 * Incluye todos los Markdown de `docs/` en el bundle (Vite ?raw).
 * Rutas clave: `consola/inicio`, `super-admin/super-organizaciones`, `README`.
 */
const rawModules = import.meta.glob<string>('../../../../docs/**/*.md', {
  query: '?raw',
  import: 'default',
  eager: true,
});

function viteKeyToRel(vitePath: string): string | null {
  const marker = '/docs/';
  const i = vitePath.indexOf(marker);
  if (i === -1) return null;
  let rel = vitePath.slice(i + marker.length);
  if (rel.endsWith('.md')) rel = rel.slice(0, -3);
  return rel.replace(/\\/g, '/');
}

const byRel = new Map<string, string>();
for (const [key, content] of Object.entries(rawModules)) {
  const rel = viteKeyToRel(key);
  if (rel) byRel.set(rel, content);
}

export function getDocMarkdown(rel: string): string | undefined {
  return byRel.get(rel);
}

export function hasDoc(rel: string): boolean {
  return byRel.has(rel);
}
